
import React from 'react';

export const CurrencyDollarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    attach_money
  </span>
);